module.exports = __webpack_public_path__ + "media/images/stories/256_rsz_euan-carmichael-666378-unsplash-3db7b04cdc8342ec7aafbebb341b2ad7.jpg";